import { createContext } from "react";
import type { AppConfig } from "@/types/AppConfig";

export const AppConfigContext = createContext<AppConfig | null>(null);
